import * as firebase from 'firebase/app';
import 'firebase/analytics';

class GoogleAnalytics {
  private analytics;
  constructor() {
    this.analytics = firebase.analytics();
  }

  setCurrentScreen(screenName) {
    this.analytics.setCurrentScreen(screenName);
  }
}

const goolgeAnalytics = new GoogleAnalytics();
export default goolgeAnalytics;


// WEBPACK FOOTER //
// ./src/app/modules/user/analytics/GoogleAnalytics.ts